"use strict";

var _classCallCheck = require("/app/front/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/app/front/node_modules/@babel/runtime/helpers/createClass.js");

var _get = require("/app/front/node_modules/@babel/runtime/helpers/get.js");

var _inherits = require("/app/front/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/app/front/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/app/front/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var FixedParser_1 = __importDefault(require("./FixedParser"));

var BooleanParser = /*#__PURE__*/function (_FixedParser_1$defaul) {
  _inherits(BooleanParser, _FixedParser_1$defaul);

  var _super = _createSuper(BooleanParser);

  function BooleanParser() {
    _classCallCheck(this, BooleanParser);

    return _super.call(this, 1);
  }

  _createClass(BooleanParser, [{
    key: "deserialize",
    value: function deserialize(state) {
      var data = _get(_getPrototypeOf(BooleanParser.prototype), "deserialize", this).call(this, state);

      return data[0] === 1 ? 1 : 0;
    }
  }, {
    key: "serialize",
    value: function serialize(data) {
      return _get(_getPrototypeOf(BooleanParser.prototype), "serialize", this).call(this, new Uint8Array([data ? 1 : 0]));
    }
  }]);

  return BooleanParser;
}(FixedParser_1.default);

exports.default = BooleanParser;